import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../../styles/detailStyles.css';
import PCLayout from '../../PCLayout';

const BlogDetailPage = ({ isDarkMode, toggleTheme }) => {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [selectedBlog, setSelectedBlog] = useState(null);

    useEffect(() => {
        fetch('/data/blogs.json')
            .then(response => response.json())
            .then(data => setBlogs(data))
            .catch(error => console.error('Error fetching blogs data:', error));
    }, []);

    const openModal = (blog) => {
        setSelectedBlog(blog);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedBlog(null);
        document.body.style.overflow = 'auto';
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        };

        if (selectedBlog) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [selectedBlog]);

    const handleBack = () => {
        navigate('/misc', { state: { targetSection: 'blog' } });
    };

    return (
        <PCLayout
            isDarkMode={isDarkMode}
            toggleTheme={toggleTheme}
            activePage="blog"
        >

            <div className="detailPageContent">
                <div className="inlineBackButtonContainer">
                    <button onClick={handleBack} className="inlineBackButton">
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                </div>
                <div className="cardGrid">
                    {blogs.map((blog) => (
                        <div className="card blogCard" key={blog.id} onClick={() => openModal(blog)}>
                            <div className="cardImage">
                                <img src={blog.image || "/images/placeholder/blog.png"} alt={blog.title} />
                            </div>

                            <h3 className="cardTitle">{blog.title}</h3>
                            <span className="cardDate">{blog.date}</span>
                            <p className="cardSummary">{blog.summary || blog.content}</p>
                            <button className="cardButton">
                                Read More <i className="fa-solid fa-arrow-right"></i>
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            {selectedBlog && (
                <div className="modalOverlay" onClick={closeModal}>
                    <div className="detailModalContent" onClick={(e) => e.stopPropagation()}>
                        <button className="detailModalClose" onClick={closeModal}>&times;</button>
                        <div className="detailModalHeader">
                            <h2 className="detailModalTitle">{selectedBlog.title}</h2>
                            <span className="detailModalDate">{selectedBlog.date}</span>
                        </div>
                        <div className="detailModalBody">
                            <p className="detailModalText">
                                {selectedBlog.content}
                            </p>
                        </div>
                    </div>
                </div>
            )}

        </PCLayout>
    );
};

export default BlogDetailPage;
